// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unit-convert .convert-btn[data-v-630f131f] {\n  margin-left: 28px;\n}\n.unit-convert .custom-row[data-v-630f131f] {\n  display: flex;\n  margin-top: 18px;\n}\n.unit-convert .custom-row .form-item-label[data-v-630f131f] {\n  width: 125px;\n  padding: 0 12px 0 0;\n  text-align: right;\n  flex-shrink: 0;\n}\n.unit-convert .custom-row .form-item-content[data-v-630f131f] {\n  flex: 1;\n}\n", ""]);
// Exports
module.exports = exports;
